



























import Vue from 'vue';

import { Button } from '@/components/ds';
import VIEWS_NAMES from '@/router/viewsNames';
import { getAssetPath } from '@/helpers/assets';

export default Vue.extend({
  components: { Button },
  data() {
    return {
      maskUrl: getAssetPath('img/section-mask.svg'),
      iconSrc: getAssetPath('img/gogo.svg'),
    };
  },
  methods: {
    navigateToSignUp() {
      this.$router.push({ name: VIEWS_NAMES.SIGN_UP });
    },
  },
});
